import { Dispatch, ReactElement, SetStateAction, useEffect, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { AxiosErrorResponse } from '@core/error.models';
import { IUseFetchOptionsParams } from '@common/api.models';
import { FormFieldMethods, IOption, UseFormReturn } from '@gcl/react-core';
import { IAdminPageFieldConfigSelect } from './admin.models';

interface IAdminPageSelectFieldProps {
  config: IAdminPageFieldConfigSelect;
  renderSelectField: (options: IOption<any>[]) => ReactElement;
  setOptionData: Dispatch<
    SetStateAction<{
      [key: string]: any;
    }>
  >;
  formFieldMethods: FormFieldMethods;
  idUseFormMethods: UseFormReturn;
}
export const AdminPageSelectField = ({
  config,
  renderSelectField,
  setOptionData,
  formFieldMethods,
  idUseFormMethods,
}: IAdminPageSelectFieldProps) => {
  const fetchFn = useMemo(() => {
    if (config.optionGetFn) return config.optionGetFn;
    return (options: IUseFetchOptionsParams) => (props?: any, enabled?: boolean) =>
      useQuery<IOption<any>[] | undefined, AxiosErrorResponse>([], async () => undefined, {
        enabled: false,
      });
  }, [config]);

  const optionGetFnGetRequest = config.optionGetFnGetRequest
    ? config.optionGetFnGetRequest(idUseFormMethods.getValues(), formFieldMethods.getValues())
    : {};

  const { data: dataOptions } = fetchFn({
    ...config.optionGetProp,
    isDirty: formFieldMethods.formState.isDirty,
  })(optionGetFnGetRequest, true);

  useEffect(() => {
    if (!dataOptions) return;
    setOptionData((old) => {
      return { ...old, [config.fieldName]: dataOptions };
    });
  }, [JSON.stringify(dataOptions)]);

  return <>{renderSelectField(dataOptions ?? [])}</>;
};
